export default __webpack_public_path__ + "static/media/house.4a1b1b0f.svg";